

import { createContext, useContext } from 'react';


export type OrientationValue = 'left' | 'right' | 'top' | 'bottom' | 'unknown';
export type OrientationPermissionStatus = 'not_requested' | 'granted' | 'denied' | 'not_required';

interface OrientationContextType {
	orientation: OrientationValue;
	sensorOrientation: OrientationValue;
	windowOrientation: OrientationValue;
	orientationPermissionStatus: OrientationPermissionStatus;
	enableOrientation: () => void;
}


const OrientationContext = createContext<OrientationContextType | null>(null);


export const useOrientation = () => {
	const context = useContext(OrientationContext);
	if (context === null) throw new Error('useOrientation must be used within an OrientationProvider');
	return {
		enableOrientation: context.enableOrientation,
		orientation: context.orientation,
		sensorOrientation: context.sensorOrientation,
		windowOrientation: context.windowOrientation,
		orientationPermissionStatus: context.orientationPermissionStatus,
	};
};

export default OrientationContext;
